<template>
    <div class="login-wrapper">
        <div class="login">
            <h1>Login</h1>
            <div v-if="timedOut" class="row no-gutters">
                <div class="col-md-12">
                    <div class="timed-out text-red text-center font-arial">
                        You have been logged out due to a period of inactivity.<br>
                        Please log back in.
                    </div>
                </div>
            </div>
            <div class="row no-gutters fields">
                <div class="col-md-6">
                    <div class="field field-left">
                        <label for="username">Username</label>
                        <input placeholder="username" name="username" type="text" v-model="username">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="field field-right">
                        <label for="password">Password</label>
                        <input placeholder="password" name="password" type="password" v-model="password" @keyup.enter="submit">
                    </div>
                </div>
            </div>
            <div v-if="notAuth" class="row no-gutters">
                <div class="col-md-12">
                    <div class="not-auth text-red text-center font-arial">
                        Your username and/or password were not recognised.<br>
                        Please try again.
                    </div>
                </div>
            </div>
            <div v-if="loginFailed" class="row no-gutters">
                <div class="col-md-12">
                    <div class="not-auth text-red text-center font-arial">
                        Sorry there was a problem logging in.<br>
                        Please try again later.
                    </div>
                </div>
            </div>

            <button @click="submit">
                <span v-if="!loggingIn">Login</span>
                <span v-if="loggingIn">Logging In..</span>
            </button>
        </div>
    </div>
</template>

<script>
    import auth from '@/util/auth';
    import store from '@/store';

    export default {
        components: {
        },
        data() {
            return {
                username: null,
                password: null,
            };
        },
        computed: {
            timedOut() {
                return store.state.timedOut;
            },
            notAuth() {
                return store.state.loginNotAuth;
            },
            loginFailed() {
                return store.state.loginFailed;
            },
            loggingIn() {
                return store.state.loggingIn;
            },
        },
        methods: {
            submit() {
                const username = this.username;
                const password = this.password;
                store.commit('setLoggingIn', true);

                auth.login(this, {
                    username,
                    password,
                }, 'Home');
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/partials/variables';
    @import '../../assets/scss/partials/mixins';

    .login-wrapper {
        text-align: center;
    }

    .login {
        display: inline-block;
        width: 100%;
        max-width: 396px;

        margin: 0 auto;
        padding-top: 41px;
    }

    h1 {
        color: $kpmg-blue;
        font-size: 45px;
        margin-bottom: 52px;
    }

    .fields {
        margin-bottom: 25px;
    }

    .field-left {
        margin-bottom: 10px;
        @media screen and (min-width: $tablet) {
            margin-bottom: 0;
            margin-right: 10px;
        }
    }

    .field-right {
        @media screen and (min-width: $tablet) {
            margin-left: 10px;
        }
    }

    label {
        display: block;
        margin-bottom: 7px;
        color: $kpmg-blue;
        font-size: 12px;
        @include fontArial();

        @media screen and (min-width: $tablet) {
            text-align: left;
        }
    }

    .timed-out {
        width: 60%;
        margin: 0 auto 25px;

        line-height: 1.2;

        @media screen and (min-width: $tablet) {
            width: 100%;
        }
    }

    .not-auth {
        width: 60%;
        margin: 0 auto 25px;

        line-height: 1.2;

        @media screen and (min-width: $tablet) {
            width: 100%;
        }
    }

    input {
        padding: 14px 0 14px 19px;
        border: 0;

        width: 60%;
        @media screen and (min-width: $tablet) {
            width: 100%;
        }
    }

    button {
        width: 100%;
        padding: 14px 0;
        font-size: 20px;
        font-weight: bold;
        color: white;

        background-color: $teal-blue;

        cursor: pointer;

        width: 60%;
        @media screen and (min-width: $tablet) {
            width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue